import { IonSpinner } from '@ionic/react'
import { myPalette } from '~/shared/ui/theme'
import { Wrapper } from './styled'

type ProgressHeadingProps = {
  height?: number
  size?: number
  color?: string
}

export function ProgressBlock({
  height = 300,
  size,
  color = myPalette.limeGreen.main,
}: ProgressHeadingProps) {
  const styleSize = size ? { width: `${size}px`, height: `${size}px` } : {}

  return (
    <Wrapper $height={height}>
      <IonSpinner name='bubbles' style={{ ...styleSize, color }} />
    </Wrapper>
  )
}
